import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { publishedBooks } from '../mockData';

const PublishedBooks = () => {
  return (
    <div style={{ backgroundColor: '#f8fafc', minHeight: '100vh', padding: '80px 0' }}>
      <div className="container-custom">
        <Link to="/books" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', color: '#667eea', textDecoration: 'none', marginBottom: '30px', fontWeight: '600' }}>
          <ArrowLeft size={20} />
          <span>Back to Books</span>
        </Link>

        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '60px' }}>
            <div style={{
              display: 'inline-block',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: 'white',
              padding: '12px 30px',
              borderRadius: '25px',
              fontSize: '1rem',
              fontWeight: 'bold',
              marginBottom: '20px'
            }}>
              📚 PUBLISHED COLLECTION
            </div>
            <h1 style={{ color: '#2d3748', fontSize: '3rem', fontWeight: 700, marginBottom: '20px' }}>Published Books</h1>
            <p style={{ color: '#718096', fontSize: '1.2rem', maxWidth: '600px', margin: '0 auto' }}>
              Explore our comprehensive collection of academic publications and research books
            </p>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '40px' }}>
            {publishedBooks.map((book) => (
              <div
                key={book.id}
                style={{
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  padding: '3px',
                  borderRadius: '20px',
                  boxShadow: '0 8px 32px rgba(102, 126, 234, 0.2)',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-8px)';
                  e.currentTarget.style.boxShadow = '0 12px 40px rgba(102, 126, 234, 0.3)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 8px 32px rgba(102, 126, 234, 0.2)';
                }}
              >
                <div style={{
                  backgroundColor: 'white',
                  borderRadius: '17px',
                  overflow: 'hidden'
                }}>
                  <div style={{ height: '400px', overflow: 'hidden', backgroundColor: '#f7fafc', position: 'relative' }}>
                    <img 
                      src={book.cover} 
                      alt={book.title} 
                      style={{ 
                        width: '100%', 
                        height: '100%', 
                        objectFit: 'cover',
                        transition: 'transform 0.3s ease'
                      }} 
                      onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'}
                      onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                    />
                    <div style={{
                      position: 'absolute',
                      top: '15px',
                      right: '15px',
                      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                      color: 'white',
                      padding: '6px 12px',
                      borderRadius: '15px',
                      fontSize: '0.8rem',
                      fontWeight: 'bold'
                    }}>
                      📖 PUBLISHED
                    </div>
                  </div>
                  <div style={{ padding: '30px' }}>
                    <h3 style={{ 
                      color: '#2d3748', 
                      fontSize: '1.4rem', 
                      fontWeight: 700, 
                      marginBottom: '15px', 
                      lineHeight: '1.3',
                      minHeight: '60px'
                    }}>
                      {book.title}
                    </h3>
                    <div style={{ marginBottom: '12px' }}>
                      <span style={{ 
                        color: '#667eea', 
                        fontSize: '0.9rem', 
                        fontWeight: 600,
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px'
                      }}>
                        👨‍🏫 Editor:
                      </span>
                      <p style={{ 
                        color: '#4a5568', 
                        fontSize: '1rem', 
                        fontWeight: 600,
                        margin: '5px 0 0 0'
                      }}>
                        {book.editor}
                      </p>
                    </div>
                    <div>
                      <span style={{ 
                        color: '#667eea', 
                        fontSize: '0.9rem', 
                        fontWeight: 600,
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px'
                      }}>
                        📋 ISBN:
                      </span>
                      <p style={{ 
                        color: '#718096', 
                        fontSize: '0.95rem',
                        fontFamily: 'monospace',
                        margin: '5px 0 0 0'
                      }}>
                        {book.isbn}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div style={{ textAlign: 'center', marginTop: '60px' }}>
            <div style={{
              background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
              padding: '30px',
              borderRadius: '20px',
              color: 'white'
            }}>
              <h3 style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '15px' }}>
                📚 Want to Publish Your Book?
              </h3>
              <p style={{ fontSize: '1.1rem', marginBottom: '25px', opacity: 0.9 }}>
                Join our community of published authors and researchers
              </p>
              <Link to="/books/publish" style={{ textDecoration: 'none' }}>
                <button style={{
                  padding: '15px 35px',
                  backgroundColor: 'white',
                  color: '#f5576c',
                  border: 'none',
                  borderRadius: '25px',
                  fontSize: '1rem',
                  fontWeight: 700,
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  textTransform: 'uppercase',
                  letterSpacing: '1px'
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 6px 20px rgba(0,0,0,0.2)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = 'none';
                }}>
                  Get Started
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PublishedBooks;